import { Request } from 'api';
import { AxiosResponse } from 'axios';
import { Organization } from 'utils';

type ReturnType = Promise<AxiosResponse<Array<Organization>>>;

const getOrganizationsForAthleteUser = (): ReturnType => {
    return Request.get('/athlete-users/organizations');
};

export default getOrganizationsForAthleteUser;
